import axios from '@providers/axiosProvider';
import * as actions from './actions';
import {
  APIGetAnnualPlansRequestParams,
  APIGetAnnualPlansResponse,
  SearchParameter,
} from './types';
import { commonActions } from '@ducks/common';
import { CustomPropertySearchFromData } from '@ducks/customProperty/types';

/**
 * @summary 検索パラメータを元に年次販売集計のリストを取得
 * @param {number | null} propertyId 建物ID
 * @param {number} year 年
 * @param {number} sort ソート番号
 * @param {string} keyword 検索キーワード
 * @param {SearchParameter} params 詳細検索条件
 * @param {number[]} tagIds 選択タグIDリスト
 * @param {CustomPropertySearchFromData} customPropertySearchForm カスタムプロパティの検索条件(body)
 * @returns {void}
 */
export const getPlansAnnualTableAsync =
  (
    propertyId: number | null,
    year: number,
    sort: number,
    keyword: string,
    params: SearchParameter,
    tagIds: number[],
    customPropertySearchForm?: CustomPropertySearchFromData,
  ) =>
  async (dispatch: any) => {
    dispatch(actions.setIsLoading(true));

    const reqParams: APIGetAnnualPlansRequestParams = {
      ...params,
      year: year,
      sort: sort,
    };

    if (propertyId != null) reqParams.property_id = propertyId;
    if (keyword) reqParams.keyword = keyword;
    if (tagIds.length) reqParams.tag = tagIds.join(',');

    await axios
      .post<APIGetAnnualPlansResponse>(
        '/plans/annual/table',
        { ...customPropertySearchForm },
        { params: reqParams },
      )
      .then((response) => {
        const { items, summary, sales_summary } = response.data.result;
        dispatch(actions.setTables(items));
        dispatch(actions.setSummary(summary));
        dispatch(actions.setSalesSummary(sales_summary));
      })
      .catch(() => {
        dispatch(actions.setTables([]));
        dispatch(actions.setSummary(null));
        dispatch(actions.setSalesSummary(null));
      });

    dispatch(actions.setIsLoading(false));
  };

/**
 * @summary 検索パラメータを元に年次販売集計のリストを出力
 * @param {number | null} propertyId 建物ID
 * @param {number} year 年
 * @param {number} sort ソート番号
 * @param {string} keyword 検索キーワード
 * @param {SearchParameter} params 詳細検索条件
 * @param {number[]} tagIds 選択タグIDリスト
 * @param {CustomPropertySearchFromData} customPropertySearchForm カスタムプロパティの検索条件(body)
 * @returns {void}
 */
export const downloadPlanAnnualTableAsync =
  (
    propertyId: number | null,
    year: number,
    sort: number,
    keyword: string,
    params: SearchParameter,
    tagIds: number[],
    customPropertySearchForm?: CustomPropertySearchFromData,
  ) =>
  async (dispatch: any) => {
    dispatch(commonActions.setIsProcessing(true));

    const reqParams: APIGetAnnualPlansRequestParams = {
      ...params,
      year: year,
      sort: sort,
    };

    if (propertyId != null) reqParams.property_id = propertyId;
    if (keyword) reqParams.keyword = keyword;
    if (tagIds.length) reqParams.tag = tagIds.join(',');

    return await axios
      .post('/plans/annual/table/export', { ...customPropertySearchForm }, { params: reqParams })
      .then((response) => {
        return response.data.result;
      })
      .catch((e) => {
        alert(e.message);
        return null;
      })
      .finally(() => {
        dispatch(commonActions.setIsProcessing(false));
      });
  };
